import styled from "styled-components";
import {mainColor, subColor, textColor} from "../../assets/GlobalStyles";
import {logo_inline_w} from "../../constants/GlobalConst";

export const menuPL = "20px";

export const AsideContainer = styled.div`
	position: relative;
	padding: 20px 0;
	height: 100vh;
	background-image: linear-gradient(to left, ${textColor}, ${mainColor});
	overflow: hidden;
	transition-duration: 0.5s;
`;

export const Logo = styled.div`
	margin-left: ${menuPL};
	height: 56px;
	background-image: url(${logo_inline_w});
	background-size: contain;
	background-repeat: no-repeat;
	transition-duration: 0.3s;
`;

export const Menu = styled.ul`
	margin-top: 20px;
	width: 100%;

	& li {
		display: flex;
		flex-direction: column;
		cursor: pointer;
		transition-duration: 0.5s;

		& > a {
			display: inline-block;
			padding-left: ${menuPL};
			width: 100%;
			height: 60px;
			color: #ccc;
			margin-left: 0;
			transition-duration: 0.5s;

			&:hover {
				background-color: ${mainColor};
			}

			& span {
				display: inline-block;
				margin-top: 19px;
				margin-left: 8px;
				vertical-align: middle;
				transition-duration: 0.5s;
				white-space: nowrap;
				font-size: 14px;
			}
		}
	}
`;

export const MenuIcon = styled.div`
	float: left;
	width: 24px;
	height: 24px;
	background-size: 24px;
	background-repeat: no-repeat;
	margin: 18px 10px;
`;

export const DropIcon = styled.div`
	float: right;
	width: 10px;
	height: 6px;
	margin: -11px 18px;
	rotate: 180deg;
	background-image: url("/assets/images/common/icon_dropup.png");
	background-repeat: no-repeat;
`;

export const Narrow = styled.div`
	position: absolute;
	width: 100%;
	bottom: 0;
	display: flex;
	justify-content: flex-end;
	padding: 14px;

	& button {
		background-color: rgba(0, 0, 0, 0);
	}
`;

export const BtnNarrow = styled.div`
	width: 30px;
	height: 30px;
	background-image: url("/assets/images/aside/btn_close.png");
	background-repeat: no-repeat;
	background-size: contain;
	cursor: pointer;
	transition-duration: 0.5s;
`;

export const SubMenu = styled.div`
	background-color: #212020;
	scrollbar-color: ${subColor} ${textColor};

	::-webkit-scrollbar {
		width: 10px;
	}

	::-webkit-scrollbar-track {
		background: ${mainColor};
		border-radius: 8px;
	}

	::-webkit-scrollbar-thumb {
		background: ${mainColor};
		border-radius: 8px;
	}

	::-webkit-scrollbar-thumb:hover {
		background: ${mainColor};
	}

	transition-duration: 0.5s;
	overflow-y: ${({ length, maxLength = Number.MAX_SAFE_INTEGER }) =>
    length >= maxLength ? "scroll" : "hidden"};
	white-space: nowrap;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	padding-left: 52px;
	max-height: ${({ active, length, maxLength = Number.MAX_SAFE_INTEGER }) =>
    active ? `${((length > maxLength ? maxLength : length) * 36) + 14}px` : 0};

	& > div {
		color: #cccccc;
		font-size: 13px;
		padding: 8px 0;

		&:first-child {
			padding: ${({ length }) => (length > 1 ? "18px 0 8px" : "18px 0")};
		}

		&:last-child {
			padding: ${({ length }) => (length > 1 ? "8px 0 18px" : "18px 0")};
		}

		> a {
			padding-right: 5px;
			display: block;
			height: 20px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}
`;